define('threadsListThreadView',[
  'app',
  'module',
  'backbone',
  'tableFieldView',
  'dateUtils',
  'underscore',
  'mailsListMailLabelsView',
  'template!threadsListThreadView',
  'notificationCenter'
], function (
  App,
  Module,
  Backbone,
  FieldView,
  DateUtils,
  _,
  LabelsView,
  Tpl,
  NotificationCenter
) {
  'use strict';

  Module.exports = FieldView.extend({
    template: Tpl,
    className: 'thread-row-view ' + FieldView.prototype.className,

    regions: {
      labelsRegion: '.labels-region'
    },

    initialize: function() {
      this._bindNotificationEvents();
    },

    onRender: function() {
      this.labelsView = new LabelsView({
        model: this.model
      });
      this.getRegion('labelsRegion').show(this.labelsView);
    },

    onDestroy: function() {
      this._removeNotificationEvents();
    },

    _bindNotificationEvents: function() {
      var nc = NotificationCenter.getInstance();
      nc.on(NotificationCenter.events.EMAILS_GMAIL_API_MESSAGE_LABELS_ADDED,
          this._handleLabelChange, this);
      nc.on(NotificationCenter.events.EMAILS_GMAIL_API_MESSAGE_LABELS_REMOVED,
          this._handleLabelChange, this);
    },

    _removeNotificationEvents: function() {
      var nc = NotificationCenter.getInstance();
      nc.off(NotificationCenter.events.EMAILS_GMAIL_API_MESSAGE_LABELS_ADDED,
          this._handleLabelChange, this);
      nc.off(NotificationCenter.events.EMAILS_GMAIL_API_MESSAGE_LABELS_REMOVED,
          this._handleLabelChange, this);
    },

    _handleLabelChange: function(response) {
      if (response && response.content && response.content.content &&
          response.content.content.entitySecId === this.model.get('threadId')) {
        this.render();
      }
    },

    attributes: function() {
      var attributes = {};
      attributes['data-has-attachments'] = this.model.get('hasAttachments') ? true : false;
      attributes['data-unread'] = this.model.get('hasUnread') ? true : false;
      return attributes;
    },

    serializeData: function() {
      var data = {};
      if(this.model) {
        data.unreadStatus = this.model.get('hasUnread') ? 'unread' : 'read';
        data.senderName = this.model.getLastSenderName();
        data.subject = this.model.get('subject') || '(no subject)';
        data.snippet = this.model.get('snippet') || '';
        data.messageCount = this.model.get('messageCount') || 1;
        data.date = DateUtils.toMDYHHMMFormat(this.model.get('lastMessageDate'));
        data.hasAttachments = this.model.get('hasAttachments') || false;
        data.hasDraft = this.model.get('hasDraft') || false;
      }
      return data;
    }
  });
});

